import React from 'react';
import * as Style from './style';

const MediaChartTag = ({
 label, color, width, height, marginRight,
}) => (
	<div className="d-flex align-items-center mb-1 mb-xl-3">
		<Style.ChartTagMark
			color={color}
			width={width}
			height={height}
			marginRight={marginRight}
		/>
		<Style.ChartTagText>{ label }</Style.ChartTagText>
	</div>

);

export default MediaChartTag;
